import React from "react";
import { Link } from "react-router-dom";

import standardRoofVanImg from "../../assets/images/Home/chiller-van-for-refrigerated-transport.webp";
import cargoBodyImg from "../../assets/images/Home/freezer-truck-service-chiller-van.webp";

export const chillerVanAlBarshaSections = [
  {
    type: "cvb-hero",
    title: "Chiller Van Rental in Al Barsha — Standard Roof Vans Cleared for Hotel Basements and Mall Service Bays",
    paragraphs: [
      <>Chiller Fleet Transport provides <strong>chiller van rental in Al Barsha</strong> from our branch inside the district, with 5 chiller vans allocated to hospitality, mall and office catering work across western Dubai.</>,
      "Every van holds 0°C to 8°C across payloads of 1 to 1.5 tons. The five vans allocated to Al Barsha district work are all standard roof, because hotel basements and mall service bays across the district cap clearance at 2.0 to 2.1 metres.",
      "Response inside Al Barsha 1, 2, 3 and Barsha Heights runs 15 to 30 minutes from booking confirmation. Rates start at AED 250 a day self-drive. Contact our team with your receiving window and delivery point to confirm availability.",
    ],
  },

  {
    type: "cvb-text-image",
    title: "Why Al Barsha Deliveries Need a Standard Roof Van",
    paragraphs: [
      "This is the constraint that decides whether a delivery happens at all, and it catches suppliers who size a vehicle by cargo volume alone.",
      <>Hotel basements, underground commercial loading docks and mall service bays across Al Barsha enforce height clearance between <strong>2.0 and 2.1 metres</strong>. A high roof Hiace with a roof-mounted thermo unit stands roughly 2.28 to 2.41 metres. That is not a tight fit — it is 180 to 310 millimetres over the barrier, and the van does not get through.</>,
      "What happens next is the expensive part. A vehicle turned back at a security barrier has not just lost its slot; it has lost the receiving window entirely, because hotel and mall docks do not reopen later in the day for a supplier who arrived with the wrong vehicle. Third-party suppliers sending high roof vans or box trucks to Al Barsha hotels and Mall of the Emirates docks are routinely refused at the gate and forced into an emergency transfer to a standard roof unit.",
      "Every van we assign to Al Barsha basement and service bay work is standard roof. The cargo volume is smaller than a high roof body offers, and that trade is the right one — a slightly smaller load that reaches the kitchen beats a larger one refused at the ramp.",
    ],
    image: standardRoofVanImg,
    imageAlt: "Standard roof chiller van cleared for hotel basement and mall service bay access in Al Barsha",
    reverse: false,
    altBg: false,
  },

  {
    type: "cvb-table",
    title: "Receiving Windows Across Al Barsha",
    description: "Al Barsha runs on service hours, not dock hours. Three different clocks operate across the district, and a route built without them spends the morning waiting.",
    columns: ["Receiving point", "Primary window", "Secondary window"],
    rows: [
      ["Hotel service entrances", "06:00 – 10:00", "15:00 – 17:00"],
      ["Mall loading bays", "05:00 – 09:30", "23:30 – 04:00"],
      ["Standalone restaurant kitchens", "08:00 – 11:30", "—"],
    ],
    notes: [
      "Hotels take their main delivery before chef prep begins for lunch service, with a secondary afternoon slot for dinner resets. Miss both and the kitchen works the evening on what it already has.",
      "Mall loading bays close to deliveries before retail doors open to the public at 10:00. The late-night window from 23:30 is the alternative, and it suits bulk restocking better than perishables, which would then sit for ten hours before trading.",
      "Standalone restaurants and cafés along Al Barsha 1 receive mid-morning, timed so stock is checked and stored before the afternoon dining peak.",
      "The pattern across all three is that the window is tied to someone else's service clock. Our vans are pre-cooled at the branch before departure and staged against the receiving time rather than dispatched when the booking lands.",
    ],
  },

  {
    type: "cvb-text-only",
    title: "Mall of the Emirates Delivery Protocol",
    paragraphs: [
      "We run scheduled deliveries across Mall of the Emirates service loading bays 2, 4, 6, 7 and 8, and access there follows a fixed procedure.",
      "Entry requires pre-registered number plate recognition at the designated service gates off Sheikh Zayed Road and the Al Barsha access roads. The driver presents a valid Emirates ID for badge exchange at the loading dock marshal desk, then moves cargo through service corridors and freight lifts directly to restaurant back doors.",
      <><strong>The off-peak window runs 05:00 to 09:00 and is strictly enforced.</strong> Outside it, daytime restocking between 10:00 and 22:00 requires a mall management dock pass and is limited to hand-trolley offloading from an assigned bay slot — slower, and dependent on a pass arranged in advance rather than on the day.</>,
      "Vehicles assigned to Mall of the Emirates runs are registered ahead of the delivery date, so plate recognition clears at the gate rather than stalling there. The same applies at My City Centre Al Barsha.",
    ],
  },

  {
    type: "cvb-text-image",
    title: "Who We Supply Across Al Barsha",
    paragraphs: [
      "Four business types account for most of the chilled volume our vans carry in the district, and none of them is industrial.",
      <><strong>Luxury hotels and resorts</strong> take fresh food service drops, banquet catering stock and specialty meat and dairy directly to back-of-house service docks. These are daily runs against a fixed morning window.</>,
      <><strong>Mall food service and F&amp;B outlets</strong> inside Mall of the Emirates and My City Centre Al Barsha take scheduled daily ingredient restocking for high-volume restaurants, food court vendors and cafés.</>,
      <><strong>Standalone restaurants and cafés</strong> along Al Barsha 1 — Arabic sweet shops, artisanal bakeries and dark kitchens — need fast-turnaround daily drops with short notice tolerance.</>,
      <><strong>Corporate and office catering</strong> moves prepared buffet trays, juice and event catering into Barsha Heights and the Al Barsha 1 commercial towers. Vans use ground-level service bays or standard 2.0 metre basement loading spaces for freight lift access to office floors.</>,
    ],
    image: cargoBodyImg,
    imageAlt: "Insulated chiller van cargo body for hotel, mall and office catering deliveries in Al Barsha",
    reverse: true,
    altBg: true,
  },

  {
    type: "cvb-table",
    title: "Chiller Van Rental Rates From Al Barsha",
    description: "Rates cover runs originating at the Al Barsha branch. Transit times are door to door before any gate or dock queue.",
    columns: ["Destination", "Self-drive", "With driver", "Off-peak", "Peak"],
    rows: [
      ["Al Quoz Industrial", "AED 250", "AED 250", "10–15 min", "20–25 min"],
      ["Dubai Marina / JBR", "AED 250", "AED 300", "10–15 min", "20–30 min"],
      ["Business Bay / Downtown", "AED 250", "AED 300", "15–20 min", "30–40 min"],
      ["Ras Al Khor", "AED 250", "AED 300", "20–25 min", "35–45 min"],
      ["Jebel Ali — JAFZA", "AED 300", "AED 350", "25–30 min", "45–55 min"],
      ["Dubai Investment Park", "AED 300", "AED 350", "25–35 min", "40–50 min"],
    ],
    notes: [
      <>All figures are starting rates, confirmed against cargo type and duration before booking. Weekly and monthly terms carry lower per-day rates, set out on <Link to="/chiller-van-for-rent" className="internal-link">our Dubai chiller van fleet</Link> page. UAE VAT applies where applicable.</>,
    ],
    background: "#f8f9fa",
  },

  {
    type: "cvb-text-only",
    title: "Fast Response Across Western Dubai",
    paragraphs: [
      <>A booking inside Al Barsha 1, 2, 3 or Barsha Heights puts a pre-cooled van on site in <strong>15 to 30 minutes</strong>.</>,
      "The branch also covers Umm Suqeim, Al Sufouh, Dubai Marina, JLT and Al Quoz 1 to 4 within a 20 to 30 minute response. A chiller van for rent on those routes leaves from inside the area rather than being brought across the city, which during peak traffic saves the 35 to 50 minutes a Ras Al Khor positioning run would take before the job starts.",
      "That margin matters most against the receiving windows above. A hotel dock closing at 10:00 and a van that needs 50 minutes to arrive are not compatible after 09:00.",
      <>Full fleet and configuration detail is on our <Link to="/chiller-van-for-rent" className="internal-link">chiller van fleet specifications page</Link>.</>,
    ],
  },

  {
    type: "cvb-faq",
    title: "Frequently Asked Questions",
    faqs: [
      {
        q: "Can a high roof chiller van for rent deliver to Al Barsha hotels or Mall of the Emirates?",
        a: "No. Basement and service bay clearance across the district caps at 2.0 to 2.1 metres, and a high roof van with a thermo unit stands around 2.28 to 2.41 metres. Every van we assign to Al Barsha basement and dock work has a standard roof for that reason.",
      },
      {
        q: "How quickly can a chiller van reach my Al Barsha address?",
        a: "Fifteen to thirty minutes from booking confirmation across Al Barsha 1, 2, 3 and Barsha Heights. Umm Suqeim, Al Sufouh, Dubai Marina, JLT and Al Quoz fall inside a 20 to 30 minute response from the same branch.",
      },
      {
        q: "Do you deliver inside Mall of the Emirates?",
        a: "Yes, across service loading bays 2, 4, 6, 7 and 8. Vehicles are pre-registered for plate recognition before the delivery date, and the enforced off-peak window runs 05:00 to 09:00. Daytime delivery requires a mall management dock pass.",
      },
    ],
  },

  {
    type: "cta",
    title: "Book a Chiller Van for rent in Al Barsha",
    paragraphs: [
      "Five standard roof chiller vans are based at our Al Barsha branch, cleared for hotel basements, mall service bays and office tower loading areas across western Dubai.",
      "Tell us your delivery point and your receiving window. If the drop is into a basement dock or a mall bay, say so at booking — we register the vehicle ahead of the date rather than resolving it at the gate.",
    ],
  },
];
